import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i2.7
import React from 'react';
import IconWrap from '../../IconWrap';
const Bold = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M10.003 10h3.003c1 0 1-2 0-2h-3.003v2zm0 3v3h3.003c2.002 0 2.002-3 0-3h-3.003zm3.786 6H9.002A2 2 0 017 17V7a2 2 0 012.002-2h3.914c1.482 0 2.646.639 3.406 1.792a4.022 4.022 0 01.168 4.145 4.115 4.115 0 01-.512.737c1.079.576 1.88 1.693 2 2.899.116 1.151-.236 2.239-.99 3.066-.788.865-1.954 1.361-3.2 1.361z"
    })));
};
Bold.displayName = 'Bold';
export default Bold;
